import Drawer, { drawerClasses } from "@mui/material/Drawer";
import { AuditDrawerDetails } from "../home/AuditDrawerDetails";
import { Divider, IconButton, styled, Typography, useTheme } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { togglreAuditDetailsDrawerState } from "../../reduxStore/getAuditList/getAuditListSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../reduxStore/store";

interface RightSideMenuProps {
    isDrawerOpen: boolean | undefined;
}
const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
}));

export default function RightSideMenu({ isDrawerOpen }: RightSideMenuProps) {
    const theme = useTheme();
    const dispatch = useDispatch<AppDispatch>();
    const handleDrawerClose = () => {
        dispatch(togglreAuditDetailsDrawerState(false))
    };

    return (
        <Drawer
            anchor="right"
            variant="permanent"
            sx={{
                "&.MuiDrawer-root .MuiDrawer-paper": { marginTop: "80px" },
                mt: 10,
                [`& .${drawerClasses.paper}`]: {
                    width: isDrawerOpen ? 400 : 0,
                },
                width: isDrawerOpen ? 400 : 0,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: {
                    width: isDrawerOpen ? 400 : 0,
                    boxShadow: "none",
                    borderRight: "none",
                    alignItems: "center",
                    borderLeft: `1px solid ${theme.palette.divider}`,
                    borderTop: `1px solid ${theme.palette.divider}`,
                },
            }}
        >
            <DrawerHeader>
                <Typography variant="h6" sx={{ flexGrow: 1, textAlign: 'center', mr: 6 }}>
                    Audit Details
                </Typography>
                <IconButton onClick={handleDrawerClose} sx={{ ml: 'auto' }}>
                    <CloseIcon />
                </IconButton>
            </DrawerHeader>
            <Divider />
            <AuditDrawerDetails />
        </Drawer>
    );
}